import React from 'react'
import { HeadFC } from 'gatsby'

import Seo from '@src/components/Seo'
import CategoryLayout from '@src/components/CategoryLayout'
import { PageContext, useTranslation } from '@models/Translation'
import { useAllArticles } from '@models/Article'

const RequestPage: React.FC = () => {
  const { locale } = useTranslation()
  const articles = useAllArticles().filter(
    article => typeof article.data.requester === 'string',
  )

  // 英語は存在しないのでHEADでリダイレクトする
  if (locale === 'en') {
    return <></>
  }

  return (
    <CategoryLayout
      articles={articles}
      category="REQUEST"
      subTitle="リクエスト記事"
      displaysCategoryInArticleList
      displaysRequestButton
    />
  )
}

export const Head: HeadFC<undefined, PageContext> = ({
  location,
  pageContext,
}) => (
  <>
    {pageContext.language === 'ja' ? (
      <Seo pathName={location.pathname} title="REQUEST ARTICLES" />
    ) : (
      <>
        <meta name="robots" content="noindex" />
        <meta httpEquiv="refresh" content={'1; url=/en'} />
      </>
    )}
  </>
)

export default RequestPage
